import React from "react";
import {TableRow, TableCell, Skeleton} from "@mui/material";

const ReportLogListSkeleton = () => {

    let items = [];

    for (let i = 0; i < 5; i++) {
        items.push(
            <TableRow key={i} sx={{'&:hover': {backgroundColor: "#fff"}}}>
                <TableCell style={{border: "none"}}><Skeleton variant="text" sx={{backgroundColor: "#d8d8fdbd"}} height={28}/></TableCell>
                <TableCell style={{border: "none"}}><Skeleton variant="text" sx={{backgroundColor: "#d8d8fdbd"}} height={28}/></TableCell>
                <TableCell style={{border: "none"}}><Skeleton variant="text" sx={{backgroundColor: "#d8d8fdbd"}} height={28}/></TableCell>
                <TableCell style={{border: "none"}}><Skeleton variant="text" sx={{backgroundColor: "#d8d8fdbd"}} height={28}/></TableCell>
                <TableCell style={{border: "none"}}><Skeleton variant="text" sx={{backgroundColor: "#d8d8fdbd"}} height={28}/></TableCell>
                <TableCell style={{border: "none"}}><Skeleton variant="text" sx={{backgroundColor: "#d8d8fdbd"}} height={28}/></TableCell>
            </TableRow>
        )
    }

    return <>{items}</>
}

export default ReportLogListSkeleton